export default function checkMinLengthFactory(minLength) {
  return function checkMinLength(value) {
    // If value isn't defined it is considered below minLength
    if (!value) {
      return true;
    }

    if (typeof value !== "string") {
      throw new Error("checkMinLength can only validate string inputs");
    }

    const { length } = value;

    if (length >= minLength) {
      return true;
    }

    return `This field has a minimum character count of ${minLength}`;
  };
}
